module.exports = __webpack_public_path__ + "static/media/dot-unselected.4a559389.png";